/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_td_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The two texts are identical.`)
};

const es_td_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los dos textos son idénticos.`)
};

const de_td_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die beiden Texte sind identisch.`)
};

const nl_td_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De twee teksten zijn identiek.`)
};

const fr_td_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les deux textes sont identiques.`)
};

const it_td_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I due testi sono identici.`)
};

const pt_br2_td_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os dois textos são idênticos.`)
};

const pt_td_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os dois textos são idênticos.`)
};

const ja_td_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2つのテキストは同じです。`)
};

const zh_td_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两段文本完全相同。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const td_empty = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.td_empty(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("td_empty", locale)
	if (locale === "en") return en_td_empty(inputs)
	if (locale === "es") return es_td_empty(inputs)
	if (locale === "de") return de_td_empty(inputs)
	if (locale === "nl") return nl_td_empty(inputs)
	if (locale === "fr") return fr_td_empty(inputs)
	if (locale === "it") return it_td_empty(inputs)
	if (locale === "pt-BR") return pt_br2_td_empty(inputs)
	if (locale === "pt") return pt_td_empty(inputs)
	if (locale === "ja") return ja_td_empty(inputs)
	return zh_td_empty(inputs)
};